// assets
import { RiseOutlined, ShoppingOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

// icons
const icons = {
  RiseOutlined,
  ShoppingOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const commerce = {
  id: 'commerce_parent',
  title: '',
  type: 'group',
  children: [
    {
      id: 'commerce',
      title: <FormattedMessage id="commerce.commerce" />,
      type: 'collapse',
      icon: icons.ShoppingOutlined,
      children: [
        {
          id: 'ambition-performance',
          title: <FormattedMessage id="commerce.ambition-performance" />,
          icon: icons.RiseOutlined,
          type: 'item',
          url: '/commerce'
        }
      ]
    }
  ]
};

export default commerce;
